/** DOM id for the primary billing actions row - used by billing screens and enforcement CTAs. */
export const BILLING_MANAGE_SECTION_ELEMENT_ID = 'billing-manage-anchor' as const;

/** DOM id for the available plans section - used by billing warning CTAs. */
export const AVAILABLE_PLANS_SECTION_ELEMENT_ID = 'available-plans-anchor' as const;

/** Hash target for deep-linking to the available plans section. */
export const AVAILABLE_PLANS_HASH = `#${AVAILABLE_PLANS_SECTION_ELEMENT_ID}` as const;

/** Strips trailing slashes so route comparisons match suspension gates and React Router paths. */
export function normalizeBillingProfilePathname(pathname: string): string {
  if (pathname.length > 1 && pathname.endsWith('/')) {
    return pathname.slice(0, -1);
  }
  return pathname;
}

/** Personal subscription management (Stripe B2C). */
export const PROFILE_BILLING_PATH = '/profile/billing' as const;

/** Organization subscription management (B2B). */
export const PROFILE_ENTERPRISE_BILLING_PATH = '/profile/enterprise-billing' as const;

export type BillingProfileManagementPath =
  | typeof PROFILE_BILLING_PATH
  | typeof PROFILE_ENTERPRISE_BILLING_PATH;

/**
 * Profile route for updating payment when the user has organization (B2B) vs personal (B2C) billing.
 * Used by billing enforcement UI and suspension redirects.
 */
export function billingProfileManagementPath(
  hasOrganizationContext: boolean,
): BillingProfileManagementPath {
  return hasOrganizationContext ? PROFILE_ENTERPRISE_BILLING_PATH : PROFILE_BILLING_PATH;
}
